import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import {
  FindingFromConditionError,
  FindingFromConditionRequest,
  FindingFromConditionResponse,
} from '@/api/model';

const request = {
  postFindingFromCondition: async ({ payload }: FindingFromConditionRequest) => {
    const { data } = await fetchClient.FCT.post<FindingFromConditionResponse>(
      ENDPOINTS.FCT.FINDING_FROM_CONDITION.BASE,
      { body: payload },
    );

    return data;
  },
};

const mutation = {
  usePostFindingFromCondition: () =>
    useMutation<
      FindingFromConditionResponse,
      FindingFromConditionError,
      FindingFromConditionRequest
    >({
      mutationFn: request.postFindingFromCondition,
    }),
};

export const findingFromCondition = {
  mutation,
  request,
};
